import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ResetPassword = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [validToken, setValidToken] = useState(null);

    // Check token on load
    useEffect(() => {
        if (!token) {
            toast.error('Invalid or missing reset link.');
            setValidToken(false);
            return;
        }
        setValidToken(true);
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!token) {
            toast.error('Invalid reset link.');
            return;
        }
        
        if (newPassword !== confirmPassword) {
            toast.error('Passwords do not match.');
            return;
        }
        
        if (newPassword.length < 8) {
            toast.error('Password must be at least 8 characters.');
            return;
        }

        setLoading(true);

        try {
            // ✅ FIXED: Use full backend URL with port 3000
            const response = await fetch('http://localhost:3000/api/reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    token,
                    newPassword,
                    confirmPassword
                })
            });

            const data = await response.json();

            if (response.ok) {
                toast.success(data.message || 'Password reset successful!');
                setTimeout(() => navigate('/login'), 2000);
            } else {
                toast.error(data.message || 'Failed to reset password.');
            }
        } catch (error) {
            toast.error('Server error. Please try again.');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    if (validToken === false) {
        return (
            <div style={styles.container}>
                <div style={styles.card}>
                    <h2 style={styles.title}>Invalid Link</h2>
                    <p>The password reset link is invalid or expired.</p>
                    <button 
                        onClick={() => navigate('/forgot-password')}
                        style={styles.button}
                    >
                        Request New Link
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.title}>Set New Password</h2>
                
                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        style={styles.input}
                        required
                    />
                    
                    <input
                        type="password"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        style={styles.input}
                        required
                    />
                    
                    <button 
                        type="submit" 
                        disabled={loading}
                        style={{...styles.button, opacity: loading ? 0.7 : 1}}
                    >
                        {loading ? 'Resetting...' : 'Reset Password'}
                    </button>
                </form>
                
                <p style={styles.link}>
                    <a href="/login" style={styles.linkText}>Back to Login</a>
                </p>
            </div>
            <ToastContainer position="top-center" />
        </div>
    );
};

const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '20px'
    },
    card: {
        background: 'white',
        padding: '30px',
        borderRadius: '10px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        width: '100%',
        maxWidth: '400px'
    },
    title: {
        textAlign: 'center',
        color: '#333',
        marginBottom: '30px'
    },
    input: {
        width: '100%',
        padding: '12px',
        marginBottom: '15px',
        border: '1px solid #ddd',
        borderRadius: '5px',
        fontSize: '16px',
        boxSizing: 'border-box'
    },
    button: {
        width: '100%',
        padding: '12px',
        background: '#4CAF50',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        fontSize: '16px',
        cursor: 'pointer',
        marginTop: '10px'
    },
    link: {
        textAlign: 'center',
        marginTop: '20px',
        color: '#666'
    },
    linkText: {
        color: '#667eea',
        textDecoration: 'none'
    }
};

export default ResetPassword;